import VueApexCharts from 'vue-apexcharts'
import api from '../../services/service_report'
import Swal from 'sweetalert2'
import moment from 'moment'

export default {
  data () {
    return {
      dateNow: this.dateMonth(new Date()),
      data_month: '',
      data_home: '',
      zone_list: [],
      zone: '',
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      }
    }
  },
  components: {
    apexchart: VueApexCharts
  },
  methods: {
    getHome () {
      this.$store.state.isLoading = true
      api.getHome(
        {
          search: '',
          date: this.dateNow + '-01',
          zone: this.zone,
          active_page: 1,
          per_page: 5000

        },
        this.header,
        result => {
          if (result.response === true) {
            this.$store.state.isLoading = false
            this.data_home = JSON.stringify(result.data.pagination)
            this.data_month = this.monthYearFormat(this.dateNow)
            this.$refs.pdf.submit()
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
            this.$store.state.isLoading = false
            this.data_home = ''
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.data_home = ''
          this.$store.state.isLoading = false
        }
      )
    },
    getHomeExcel () {
      this.$store.state.isLoading = true
      api.getHome(
        {
          search: '',
          date: this.dateNow + '-01',
          zone: this.zone,
          active_page: 1,
          per_page: 5000

        },
        this.header,
        result => {
          if (result.response === true) {
            this.$store.state.isLoading = false
            this.data_home = JSON.stringify(result.data.pagination)
            this.data_month = this.monthYearFormat(this.dateNow)
            this.$refs.excel.submit()
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
            this.$store.state.isLoading = false
            this.data_home = ''
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.data_home = ''
          this.$store.state.isLoading = false
        }
      )
    },
    getZoneAll () {
      var obj = {
        search: '',
        active_page: 1,
        per_page: 100000000
      }
      api.getZone(obj, this.header,
        result => {
          if (result.response === true) {
            this.zone_list = result.data.pagination
          } else {
            Swal.fire('ดึงข้อมูลสิทธิ์', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.getZoneAll()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/home_report.js